export const copyToClipboard = (text: string): Promise<void> => {
  if (navigator && navigator.clipboard) {
    return navigator.clipboard.writeText(text);
  } else {
    return Promise.reject("navigator.clipboard is not available");
  }
};
